<!-- <div class="container" style="height: 500px"> -->
<div class="container d-grid gap-3 p-2">
  <h1 class="text-center my-2 py-2">LOS Tokens and Mappings</h1>

  <div class="grid-container">
    @if(settingsReady)
    {
      <app-lt-png-table [gridSettingsInput]="gridSettings()">
        <ng-template appGridTemplate="expandedrow" let-data let-rowIndex="rowIndex ">
          <section>
            <app-los-token-mapping-view [data]="data" (mappingDataChanged)="reloadActiveToken()" />
          </section>
        </ng-template>
      </app-lt-png-table>
    }
  </div>
</div>
